const SPACING = 2;
export const YEARS = ["2025", "2030", "2035", "2040", "2045", "2050"];
export const SCENARIOS = [
  "IMA15tot",
  "Faster Transitions",
  "TERI15D_notranpol",
  "SMP_1p5C_early",
  "CEMICS15_CDR8",
];

export const SCENARIOS_META = [
  {
    title: window.backendVars.copy["More energy efficiency"],
    description:
      window.backendVars.copy[
        "Based on “IMA15tot” scenario and KAPSARC analysis."
      ],
  },
  {
    title: window.backendVars.copy["Balanced"],
    description:
      window.backendVars.copy[
        "Based on “Faster Transitions” scenario and KAPSARC analysis."
      ],
  },
  {
    title: window.backendVars.copy["More energy supply"],
    description:
      window.backendVars.copy[
        "Based on “TERI15D_notranpol” scenario and KAPSARC analysis."
      ],
  },
  {
    title: window.backendVars.copy["More CCS"],
    description:
      window.backendVars.copy[
        "Based on “SMP_1p5c_early” scenario and KAPSARC analysis."
      ],
  },
  {
    title: window.backendVars.copy["More renewables"],
    description:
      window.backendVars.copy[
        "Based on “CEMICS15_CDR8” scenario and KAPSARC analysis."
      ],
  },
];

import rawData from "./rawData";
import { co2data } from "./co2data";

const rawCO2conn = JSON.parse(JSON.stringify(rawData.co2connectors));

const makeDict = (what, idField = "id") =>
  what.reduce((acc, val, index) => {
    if (!(val[idField] in acc)) {
      acc[val[idField]] = index;
    } else {
      console.error(`duplicate node id ${val[idField]}`);
    }
    return acc;
  }, {});

const nodesDict = makeDict(rawData.nodes);
let initialData = null;

export const co2connectorsDict = makeDict(rawData.co2connectors, "rel");

// maximal ValuePerPixel register
export let maxVPPCO2 = SCENARIOS.map((v) => 0);
export let maxVPP2 = SCENARIOS.map((v) => 0);

export const processData = (data, co2Variables, scenarioId = 0, yearId = 0) => {
  const co2conn = JSON.parse(JSON.stringify(rawCO2conn));
  const CO2d = JSON.parse(
    JSON.stringify(co2data)
  ).map((scenarioData, scIdx) => ({ ...scenarioData, ...co2Variables[scIdx] }));

  // store initial values from datasheet
  if (!initialData) initialData = JSON.parse(JSON.stringify(CO2d));

  // console.log({ co2Variables });
  // console.log({ co2conn });

  SCENARIOS.forEach((scenId, scenIdx) => {
    Object.keys(CO2d[scenIdx]).forEach((co2key) => {
      // calculate data based on custom fomulas
      if ("calc" in CO2d[scenIdx][co2key]) {
        const toAdd = CO2d[scenIdx][co2key].calc.add || [];
        const toSub = CO2d[scenIdx][co2key].calc.sub || [];
        const scenArr = [];
        YEARS.forEach((y, yIdx) => {
          let result = 0;
          toAdd.forEach((field) => {
            // console.log({ yIdx, field });
            if (typeof field === "number") {
              result += field;
            } else {
              result +=
                field[0] === "$"
                  ? initialData[scenIdx][field.substring(1)][yIdx]
                  : CO2d[scenIdx][field][yIdx];
            }
          });
          toSub.forEach((field) => {
            if (typeof field === "number") {
              result -= field;
            } else {
              result -=
                field[0] === "$"
                  ? initialData[scenIdx][field.substring(1)][yIdx]
                  : CO2d[scenIdx][field][yIdx];
            }
          });
          scenArr.push(result);
        });

        CO2d[scenIdx][co2key] = scenArr;
        // if (co2key[0] === '_') {
        //   calculated[scenIdx][co2key] = JSON.parse(
        //     JSON.stringify(CO2d[scenIdx][co2key]),
        //   );
        // }
      }

      let cnStr = co2key;
      // xxx-yyy-zzz case
      if (co2key.length === 11) {
        cnStr = co2key.substring(0, 3) + "-" + co2key.substring(8, 11);
      }
      const cnIdx = co2connectorsDict[cnStr];
      if (!co2conn[cnIdx]) {
        return;
      }
      const connectorData = co2conn[cnIdx].series.data[scenIdx];

      // add CO2d entry to connector data entry
      co2conn[cnIdx].series.data[scenIdx] = connectorData.map((value, idx) => {
        return value + CO2d[scenIdx][co2key][idx];
      });
    });
  });

  // console.log({ co2connectors });
  data.CO2connectors = co2conn;
  delete data.co2connectors;

  const newData = { ...data };

  newData.calculated = JSON.parse(JSON.stringify(CO2d));

  const newConnectors = newData.connectors.map((conn, connIdx) => {
    // console.log(conn.rel);
    if (!conn.rel) {
      console.error(`missing rel in ${connIdx}`);
      return conn;
    }
    const [from, to] = conn.rel.split("-");
    if (!(from in nodesDict) || !(to in nodesDict)) {
      console.error(`invalid connector relation: "${conn.rel}"`);
    }
    conn.from = {
      nodeIndex: nodesDict[from],
    };
    conn.to = {
      nodeIndex: nodesDict[to],
    };
    if (!("fPos" in conn)) {
      conn.fPos = 50;
    }
    if (!("tPos" in conn)) {
      conn.tPos = 50;
    }

    // populate values from series
    for (let prop in conn.series) {
      if (Array.isArray(conn.series[prop][scenarioId])) {
        conn[prop] = conn.series[prop][scenarioId][yearId];
      } else {
        conn[prop] = conn.series[prop][yearId];
      }
    }
    conn.normalized = {};
    return conn;
  });

  const newCO2connectors = newData.CO2connectors.map((conn, connIdx) => {
    // console.log(conn.rel);
    if (!conn.rel) {
      console.error(`missing rel in ${connIdx}`);
      return conn;
    }
    const [from, to] = conn.rel.split("-");
    if (!(from in nodesDict) || !(to in nodesDict)) {
      console.error(`invalid connector relation: "${conn.rel}"`);
    }
    conn.from = {
      nodeIndex: nodesDict[from],
    };
    conn.to = {
      nodeIndex: nodesDict[to],
    };
    if (!("fPos" in conn)) {
      conn.fPos = 50;
    }
    if (!("tPos" in conn)) {
      conn.tPos = 50;
    }

    // populate values from series
    for (let prop in conn.series) {
      if (Array.isArray(conn.series[prop][scenarioId])) {
        conn[prop] = conn.series[prop][scenarioId][yearId];
      } else {
        conn[prop] = conn.series[prop][yearId];
      }
    }
    conn.normalized = {};
    return conn;
  });

  const newNodes = newData.nodes.map((node, nodeIdx) => {
    // find incoming lines
    node.incomingCO2 = newData.CO2connectors.filter(
      (c) => c.to.nodeIndex === nodeIdx
    );
    node.incoming = newData.connectors.filter(
      (c) => c.to.nodeIndex === nodeIdx
    );

    // calculate node's incoming total values matrix[scenario][year]
    node.incomingTotalCO2 = SCENARIOS.map((scen, scenIdx) => {
      return YEARS.map((y, yIdx) => {
        let yearTotal = 0;
        if (node.incomingCO2.length) {
          node.incomingCO2.forEach((outg) => {
            yearTotal += outg.series.data[scenIdx][yIdx];
          });
        }

        return yearTotal;
      });
    });
    node.incomingTotal2 = SCENARIOS.map((scen, scenIdx) => {
      return YEARS.map((y, yIdx) => {
        let yearTotal = 0;
        if (node.incoming.length) {
          node.incoming.forEach((outg) => {
            yearTotal += outg.series.data[scenIdx][yIdx];
          });
        }

        return yearTotal;
      });
    });

    // find outgoing lines
    node.outgoingCO2 = newData.CO2connectors.filter(
      (c) => c.from.nodeIndex === nodeIdx
    );
    node.outgoing = newData.connectors.filter(
      (c) => c.from.nodeIndex === nodeIdx
    );

    // calculate node's outgoing total values matrix[scenario][year]
    node.outgoingTotalCO2 = SCENARIOS.map((scen, scenIdx) => {
      return YEARS.map((y, yIdx) => {
        let yearTotal = 0;
        if (node.outgoingCO2.length) {
          node.outgoingCO2.forEach((outg) => {
            yearTotal += outg.series.data[scenIdx][yIdx];
          });
        }

        return yearTotal;
      });
    });

    node.outgoingTotal2 = SCENARIOS.map((scen, scenIdx) => {
      return YEARS.map((y, yIdx) => {
        let yearTotal = 0;
        if (node.outgoing.length) {
          node.outgoing.forEach((outg) => {
            yearTotal += outg.series.data[scenIdx][yIdx];
          });
        }

        return yearTotal;
      });
    });

    let inDim = "w";
    let outDim = "w";
    // store incoming valuePerPixel
    node.inVPPCO2 = node.incomingTotalCO2.map((scen, scenIdx) => {
      return (
        Math.max(...scen) /
        (node[node.CO2inDim || inDim] - node.incomingCO2.length * SPACING)
      );
    });
    node.inVPP2 = node.incomingTotal2.map((scen, scenIdx) => {
      return Math.max(...scen) / (node[inDim] - node.incoming.length * SPACING);
    });

    // store outgoing valuePerPixel
    node.outVPPCO2 = node.outgoingTotalCO2.map((scen, scenIdx) => {
      return (
        Math.max(...scen) /
        (node[node.CO2outDim || outDim] - node.outgoingCO2.length * SPACING)
      );
    });
    node.outVPP2 = node.outgoingTotal2.map((scen, scenIdx) => {
      return (
        Math.max(...scen) / (node[outDim] - node.outgoing.length * SPACING)
      );
    });

    // find maximal Value Per Pixel for each scenario
    SCENARIOS.forEach((scen, scenIdx) => {
      maxVPP2[scenIdx] = Math.max(
        maxVPP2[scenIdx],
        node.outVPP2[scenIdx],
        node.inVPP2[scenIdx]
      );
      maxVPPCO2[scenIdx] = Math.max(
        maxVPPCO2[scenIdx],
        node.outVPPCO2[scenIdx],
        node.inVPPCO2[scenIdx]
      );
    });

    // console.log({ maxVPP2, maxVPPCO2 });
    return node;
  });

  // WE HAVE NOW MAX VALUE PER PIXEL AMONG ALL scenarios

  // do the actual line widths normalization
  newData.connectors.map((conn) => {
    conn.w = 0.01;

    conn.normalized.w = conn.series.data.map((scenario, scenIdx) => {
      return scenario.map((v, vIdx) => Math.max(SPACING, v / maxVPP2[scenIdx]));
    });
    conn.normalized.rawW = conn.series.data.map((scenario, scenIdx) => {
      return scenario.map((v, vIdx) => v / maxVPPCO2[scenIdx]);
    });

    // prepare positioning matrices for lines
    // just copy over normalized.w using HolyGrailOfDeepCloning
    // below those values are replaced with correct ones
    conn.normalized.tPos = JSON.parse(JSON.stringify(conn.normalized.w));
    conn.normalized.fPos = JSON.parse(JSON.stringify(conn.normalized.w));
  });

  newData.CO2connectors.map((conn) => {
    conn.w = 0.01;

    conn.normalized.w = conn.series.data.map((scenario, scenIdx) => {
      return scenario.map((v, vIdx) =>
        Math.max(SPACING, v / maxVPPCO2[scenIdx])
      );
    });

    conn.normalized.rawW = conn.series.data.map((scenario, scenIdx) => {
      return scenario.map((v, vIdx) => v / maxVPPCO2[scenIdx]);
    });

    // prepare positioning matrices for lines
    // just copy over normalized.w using HolyGrailOfDeepCloning
    // below those values are replaced with correct ones
    conn.normalized.tPos = JSON.parse(JSON.stringify(conn.normalized.w));
    conn.normalized.fPos = JSON.parse(JSON.stringify(conn.normalized.w));
  });

  // Positioning of lines along the edge of the node
  // todo: centering
  newNodes.map((node) => {
    let pos = 0;
    SCENARIOS.forEach((s, scenIdx) => {
      YEARS.forEach((y, yIdx) => {
        pos = SPACING / 2;
        node.incoming.forEach((conn) => {
          const w = conn.normalized.w[scenIdx][yIdx];
          const val = w / 2 + pos;
          pos += w + SPACING;
          conn.normalized.tPos[scenIdx][yIdx] = val;
        });
        node.incoming.forEach((conn) => {
          conn.normalized.tPos[scenIdx][yIdx] += node.w / 2 - pos / 2;
        });

        pos = SPACING / 2;
        node.outgoing.forEach((conn) => {
          const w = conn.normalized.w[scenIdx][yIdx];
          const val = w / 2 + pos;
          pos += w + SPACING;
          conn.normalized.fPos[scenIdx][yIdx] = val;
        });
        node.outgoing.forEach((conn) => {
          conn.normalized.fPos[scenIdx][yIdx] += node.w / 2 - pos / 2;
        });

        // CO2 Lines
        pos = SPACING / 2;
        node.incomingCO2.forEach((conn) => {
          const w = conn.normalized.w[scenIdx][yIdx];
          const val = w / 2 + pos;
          if (!conn.ignoreWidth) {
            pos += w + SPACING;
          }
          conn.normalized.tPos[scenIdx][yIdx] = val;
        });
        node.incomingCO2.forEach((conn) => {
          conn.normalized.tPos[scenIdx][yIdx] +=
            node[node.CO2inDim || "w"] / 2 - pos / 2;
        });

        pos = SPACING / 2;
        node.outgoingCO2.forEach((conn) => {
          const w = conn.normalized.w[scenIdx][yIdx];
          const val = w / 2 + pos;
          if (!conn.ignoreWidth) {
            pos += w + SPACING;
          }
          conn.normalized.fPos[scenIdx][yIdx] = val;
        });
        node.outgoingCO2.forEach((conn) => {
          conn.normalized.fPos[scenIdx][yIdx] +=
            node[node.CO2outDim || "w"] / 2 - pos / 2;
        });
      });
    });
  });

  newData.connectors.forEach((connector, index) => {
    connector.target = {};
    connector.w = connector.normalized.w[scenarioId][yearId];
    connector.fPos = connector.normalized.fPos[scenarioId][yearId];
    connector.tPos = connector.normalized.tPos[scenarioId][yearId];
    connector.series = JSON.parse(JSON.stringify(connector.series));
    connector.origData = JSON.parse(JSON.stringify(connector.series.data));
  });
  newData.CO2connectors.forEach((connector, index) => {
    connector.target = {};
    connector.w = connector.normalized.w[scenarioId][yearId];
    connector.rawW = connector.normalized.rawW[scenarioId][yearId];
    connector.fPos = connector.normalized.fPos[scenarioId][yearId];
    connector.tPos = connector.normalized.tPos[scenarioId][yearId];
    connector.series = JSON.parse(JSON.stringify(connector.series));
    connector.origData = JSON.parse(JSON.stringify(connector.series.data));
  });

  newData.nodes = newNodes;
  newData.connectors = newConnectors;
  newData.CO2connectors = newCO2connectors;

  return newData;
};

const theData = processData(rawData, {}, 0, 0);

export const getCustomVariables = (
  data,
  keys = ["dac-geo", "cac-reu", "nas-nes"]
) => {
  let customConnectors = data.CO2connectors.filter(
    (co2c) => keys.indexOf(co2c.rel) > -1
  );

  // console.log(customConnectors);
  const custCO2vars = [];
  SCENARIOS.forEach((sc, scIdx) => {
    let scenarioPatch = {};
    customConnectors.forEach((cc) => {
      scenarioPatch[cc.rel] = cc.series.data[scIdx];
    });
    custCO2vars.push(scenarioPatch);
  });
  return custCO2vars;
};

export default theData;
